import * as moment from 'moment';
const FORMAT = "MM/DD/YYYY";
const isValidDateOfBirth = (value) => {
  if (new Date(value) == 'Invalid Date') {
    return false;
  }
  return moment(value, FORMAT).isValid();
};
const BIDFORMAT = "YYYY-MM-DD";
const isValidDateOfBid = (value) => {
  if (new Date(value) == 'Invalid Date') {
    return false;
  }
  return moment(value, BIDFORMAT).isValid();
};

export { isValidDateOfBirth, FORMAT, isValidDateOfBid, BIDFORMAT };
